import {ImageRequestParams} from "./image-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class BettingZoneAssetsRequestParams extends ImageRequestParams {
  constructor(width: Number,height: Number, color: String) {
    super({resourceName: 'Website/BettingZone/Wordpress', width, height, color});

    this.version = 2;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
